var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"r-help"},[_c('r-title',[_vm._v(_vm._s(_vm.title))]),_c('r-text',[_vm._v(_vm._s(_vm.text))]),_c('r-button',{on:{"click":function($event){_vm.show = false}}},[_vm._v(" Понятно ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }